import { render, staticRenderFns } from "./ChallengesNews.vue?vue&type=template&id=61e44d5a&"
import script from "./ChallengesNews.vue?vue&type=script&lang=js&"
export * from "./ChallengesNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports